var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurantsOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 56,
    viewBox: "0 0 87 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3264 25.2292C57.4105 25.1163 56.4868 25.072 55.5636 25.0981H53.709V30.4925H55.8087C56.8298 30.5512 57.8543 30.451 58.845 30.1958C59.3309 30.016 59.7493 29.69 60.0432 29.2633C60.3365 28.8266 60.4887 28.3108 60.4782 27.785C60.5015 27.1573 60.284 26.5441 59.8705 26.0714C59.4654 25.6248 58.9214 25.3276 58.3265 25.2291L58.3264 25.2292Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.1777H86.5454V55.9995H0V49.1777Z",
    fill: "#FF5910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3523 47.8545H5.19238C5.19238 31.0549 15.9856 16.8 31.0542 11.7091C32.8865 11.0983 34.8213 10.589 36.8582 10.2836C38.9967 9.97825 41.1345 9.77441 43.3745 9.77441C45.6145 9.77441 47.7524 9.97825 49.8909 10.2836C51.8256 10.589 53.7602 11.0983 55.5925 11.7091C70.5591 16.8 81.3525 31.0545 81.3525 47.8545H81.3523Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0937 6.82181C50.0937 7.63645 49.9922 8.34879 49.6868 9.06181C47.5482 8.75641 45.4104 8.55258 43.1704 8.55258C40.9304 8.55258 38.7926 8.75641 36.654 9.06181C36.4502 8.34874 36.2471 7.63639 36.2471 6.82181C36.2471 3.05473 39.3018 0 43.0689 0C47.0391 0 50.0938 3.05473 50.0938 6.82181H50.0937Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantsOrange);
export default __webpack_public_path__ + "static/media/restaurants_Orange.55ba283950cb157830695d3e26ca6ba7.svg";
export { ForwardRef as ReactComponent };